import { CloseButton } from '@leroy-merlin-br/backyard-react'

import { useAlgoliaContext } from 'site/AlgoliaEntryKey/context/algolia-context'

import * as S from './styled'

const Header = () => {
  const { toggleMobileFilter } = useAlgoliaContext()

  return (
    <S.Header>
      <S.Title>Filtros</S.Title>
      <CloseButton
      onClick={toggleMobileFilter}
      />
    </S.Header>
  )
}

export default Header
